import axios from 'axios';

// const URL = "https://liga.bracards.com.br/api";
const URL = "/api";

const api = axios.create({
    baseURL: URL,
    withCredentials: true,
    headers: {
        'Accept': '*/*',
    },
});

// Interceptor para adicionar o token JWT ao cabeçalho Authorization
api.interceptors.request.use((config) => {
    const session = JSON.parse(localStorage.getItem("session"));
    if (session && session.token) {
        config.headers['Authorization'] = 'Bearer ' + session.token;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});


export default api;
